import React, { useEffect, useState } from 'react';
import { Button, Container, Card, CardBody } from 'reactstrap';
import stepData from '../../data/Steps.json';
import './index.css';
import finalImg from '../../assets/icons/final.svg';

const StepsComponent = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    setSteps(stepData);
  }, []);

  const goToNextStep = () => {
    if (currentStep <= steps.length) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const getIconImage = (iconName) => {
    if (!iconName) return null;
    if (iconName.startsWith('http')) return iconName;

    try {
      return require(`../../assets/icons/${iconName}`);
    } catch {
      console.warn(`Icon not found: ${iconName}`);
      return null;
    }
  };

  const renderMediaContent = (step) => {
    if (step.type === 'gif') {
      const gif = require(`../../assets/gif/${step.media}`);
      return <img src={gif} alt={step.title} className="img-fluid" />;
    }

    if (step.type === 'interactive') {
      return (
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
          <iframe
            src={`${step.media}?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true`}
            title={step.title}
            frameBorder="0"
            loading="lazy"
            allowFullScreen
            allow="clipboard-write"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          />
        </div>
      );
    }

    return null;
  };

  const renderStyledTitle = (title) => {
    const match = title.match(/(Step \d+)(: )(.*)/);
    if (match) {
      const [, stepLabel, colon, restTitle] = match;
      return (
        <>
          <strong className="step-number-red">{stepLabel}</strong>
          {colon}
          {restTitle}
        </>
      );
    }
    return title;
  };

  const renderStepContent = () => {
    const isFinalStep = currentStep > steps.length;

    if (isFinalStep) {
      return (
        <div className="final text-center py-5">
          <img src={finalImg} alt="" />
          <h5 className="fw-bold">You've just prepped your dataset from raw to ready all through an interactive, AI-powered chat interface. You're now ready to put your data to work. </h5>
          <p className="text-muted">
            Need help with the next steps?
          </p>
          {/* <Button className='nxt-btn' >Read the Documentation</Button> */}
          <button className="final-btn btn" onClick={() => window.open('https://documentation.astera.com/', '_blank')}>Read the Documentation</button>
        </div>
      );
    }

    const step = steps[currentStep - 1];
    const icon = getIconImage(step.icon);

    return (
      <>
        {icon && <img src={icon} alt={step.title} className="mb-3" />}
        <h5 className="step-title">{renderStyledTitle(step.title)}</h5>
        <p className="mb-4">{step.description}</p>
        <div className="mb-4">{renderMediaContent(step)}</div>
      </>
    );
  };

  return (
    <>
      <Container className="my-4 CustomContainer">
        <div className="steps-header mb-4">
          <h2 className="fw-bold mb-3">Getting Started</h2>
          <p className="text-muted">
            Start your AI-powered, zero-code data journey by following a few simple steps to upload,
            extract, and transform your data in Astera Cloud.
          </p>
        </div>
      </Container>

      <Container fluid className="main-step">
        <Container className="CustomContainer">
          <Card>
            <CardBody>
              <div className="steps-body">{renderStepContent()}</div>

              <div className={`d-flex mt-4 ${currentStep === 1 ? 'justify-content-end' : 'justify-content-between'}`}>
                <Button className='nxt-btn' onClick={goToPreviousStep} disabled={currentStep === 1} style={{ display: currentStep === 1 ? 'none' : 'inline-block' }}
                >
                  Previous
                </Button>

                {currentStep <= steps.length && (
                  <Button className='nxt-btn' color="" onClick={goToNextStep}>
                    {currentStep === steps.length ? 'Finish' : 'Next'}
                  </Button>
                )}

              </div>
            </CardBody>
          </Card>
        </Container>
      </Container>
    </>
  );
};

export default StepsComponent;
